import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const PersonOutlineIcon = (props: IconProps) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <path d="M10 4.91634c.9667 0 1.75.78333 1.75 1.75s-.7833 1.75-1.75 1.75c-.96666 0-1.74999-.78333-1.74999-1.75s.78333-1.75 1.74999-1.75Zm0 7.49996c2.475 0 5.0833 1.2167 5.0833 1.75v.9167H4.91668v-.9167c0-.5333 2.60833-1.75 5.08332-1.75Zm0-9.08329c-1.84166 0-3.33332 1.49166-3.33332 3.33333 0 1.84167 1.49166 3.33333 3.33332 3.33333 1.8417 0 3.3333-1.49166 3.3333-3.33333 0-1.84167-1.4916-3.33333-3.3333-3.33333Zm0 7.49999c-2.22499 0-6.66666 1.1167-6.66666 3.3333v2.5H16.6667v-2.5c0-2.2166-4.4417-3.3333-6.6667-3.3333Z" />
  </Icon>
);
export default memo(PersonOutlineIcon);
